{
  "fr": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Activer les unités",
          "deactivate": "Désactiver les unités",
          "give_access": "Donner accès aux clients",
          "revoke_access": "Révoquer l'accès client"
        },
        "revokeAccess": "Révoquer l'accès",
        "select": "Selectionner type",
        "selectOutdoorCategory": "Selectionner Espace Extérieur",
        "selectUnit": "Selectionner Unité",
        "setCustomer": "Affecter un client à",
        "setVisible": "Donner accès",
        "submit": "Enregistrer",
        "update_pricing": "Mettre à jour les prix"
      },
      "attributes": {
        "address_city": "Ville",
        "address_country": "Pays",
        "address_number": "Numéro",
        "address_street": "Rue",
        "address_zip": "Code Postal",
        "amount": "Montant",
        "bathrooms": "Nombre de salles de bain ",
        "bedrooms": "Nombre de chambres",
        "category": "Type d'unité",
        "category_outdoor": "Espace Extérieur",
        "customer": "Client",
        "deed_signed_at": "Acte signé le",
        "description": "Description",
        "electricity": "Electricité",
        "floor": "Étage",
        "house_subcategory": "Type de logement",
        "internal_note": "Note interne",
        "meter_number": "Numéro du compteur",
        "meter_number_electricity": "Numéro du compteur électricité",
        "meter_number_gas": "Numéro du compteur gaz",
        "meter_number_warmth": "Numéro du compteur chaleur",
        "meter_number_water": "Numéro du compteur eau",
        "meter_numbers": "Numéros de compteur",
        "name": "Nom",
        "orientation": "Orientation",
        "price_value": "Total prix de vente",
        "price_value_construction": "Quote part Construction",
        "price_value_construction_existing": "Coûts de la construction existante",
        "price_value_fees": "Honoraires d'architecte / d'ingénierie",
        "price_value_land": "Quote part Terrain",
        "quotity": "Quotité partielle",
        "sales_employee": "Représentant commercial",
        "status": "Status",
        "surface_garden": "Jardin en surface",
        "surface_terrace": "Surface terrasse",
        "surface_total": "Superficie totale",
        "tax_percentage": "Taxe %",
        "toilets": "Nombre de toilettes",
        "total": "Total",
        "vat_percentage": "TVA %"
      },
      "house_subtype": {
        "detached": "Maison Individuelle",
        "rowhouse": "Maison Mitoyenne",
        "semidetached": "Maison Jumelée"
      },
      "labels": {
        "activate": "Activer",
        "address": "Adresse",
        "areYouSureDeactivate": "Voulez-vous vraiment désactiver {unit_name}?",
        "bathrooms": "salles de bain | salles de bains",
        "bedrooms": "chambre | chambres",
        "cannot_activate_all_units": "Vous n'avez pas assez d'unités restantes pour activer toutes les unités sélectionnées",
        "deactivate": "Désactiver",
        "deactivateMessage": "Le client peut toujours communiquer avec vous et aura toujours accès à toutes ses informations. Toutes les autres actions telles que la création de décisions, le téléchargement de documents, l'envoi de formulaires, etc. pour {unit_name} ne seront néanmoins pas possibles.",
        "deactivated": "Désactivée",
        "deedSignedOn": "Acte signé le {date}",
        "deedWillBeSignedOn": "Acte sera signé le {date}",
        "detailed_price": "Prix détaillé",
        "details": "Détails",
        "email_address_secondary_delivery_content": "reçoit des e-mails de notification en tant qu'ancien contact secondaire",
        "email_address_secondary_delivery_tip": "Ce client a été initialement ajouté en tant que contact secondaire à l'autre client, avant l'introduction de la prise en charge de plusieurs clients par unité : ce client continuera à recevoir les mêmes e-mails de notification que l'autre client, mais seul l'autre client a accès à l'unité/à la connexion.",
        "existingVatValues": "Certaines valeurs de TVA sont différentes de 0",
        "export": "Exporter",
        "export_preparing": "La collecte des données de l'unité peut prendre quelques secondes.",
        "facing": "Orienté {direction}",
        "fromATotal": "Totale projet: {total}",
        "general": "Général",
        "howDoesCustomerSeeThis": "Comment le client voit-il son unité?",
        "integrationNoCustomerAssigned": "Aucun client attribué, veuillez attribuer un ou plusieurs clients dans {integration_name}.",
        "internal": "Interne",
        "internalDisclaimer": "Cette information n'est visible que pour votre équipe",
        "invitationAddEmailAddress": "Afin de permettre à {client} d'accéder à l'unité, veuillez d'abord renseigner l'adresse e-mail sur la page de contact du client.",
        "invitationAddEmailAddress_SUP": "Afin de permettre à {customer} d'accéder au projet, veuillez tout d'abord indiquer l'adresse électronique figurant sur la page de contact du client.",
        "invitationSentTo": "{customer} recevra bientôt son invitation à {email}",
        "maintainerNoCustomerAssigned": "Aucun client attribué, seuls les membres de l'équipe avec le role 'Propriétaire' peuvent affecter un client à une unité.",
        "more": "plus",
        "onFloor": "Sur étage",
        "other_units": "A d'autres unités",
        "price_view": "Vue des prix",
        "sales_value": "Tous les prix sont en {currency}",
        "scopes": {
          "invisible": "Pas d'accès à l'unité",
          "invisible_SUP": "Pas d'accès au projet",
          "visible": "Client a accès à l'unité",
          "visible_SUP": "A accès"
        },
        "search_unit": "Rechercher une unité ou client...",
        "selectUnit": "Selectionner une Unité",
        "set_unit_price": "Définir le prix unitaire",
        "showUnit": "Montrer l'Unité",
        "simple_price": "Simple",
        "toggleDetailedPrice": "Changer de vue des prix",
        "unassigned": "Aucun client affecté",
        "unit": "Aucune Unité | Une Unité | {count} Unités",
        "unitLabel": "Unité",
        "utilities": "Services Publics ",
        "visibleCustomer": "Ces informations sont visibles pour les clients"
      },
      "outdoor_category": {
        "balcony": "Balcon",
        "garden": "Jardin",
        "null": "Aucun",
        "terrace": "Terrasse",
        "terrace_garden": "Terrasse + Jardin"
      },
      "status": {
        "available": "Disponible",
        "unavailable": "Indisponible"
      },
      "toasts": {
        "activateSuccess": "{unit_name} a été activé avec succès",
        "create_fixed": "Unité créée",
        "create_rundle": "Nouvelle unité active créée. 1 unité active restante. | Nouvelle unité active créée. {count} unités actives restantes.",
        "deactivateSuccess": "{unit_name} a été désactivé avec succès",
        "delete": "Unité supprimée",
        "update": "Unité modifiée"
      },
      "type": {
        "alf": "Résidence-services",
        "apartment": "Appartement",
        "cellar": "Cave",
        "commercial": "Commercial",
        "duplex": "Duplex",
        "house": "Maison",
        "loft": "Loft",
        "office": "Office",
        "penthouse": "Penthouse",
        "sme": "PME Unité",
        "studio": "Studio"
      },
      "validation": {
        "needName": "Titre est requis",
        "needNumber": "Doit être un nombre (par exemple 85)",
        "pricesNotUpdatable": "Une partie ou tous les prix ont été utilisés pour les versements et ne peuvent donc pas être modifiés. Supprimez les versements associés afin de modifier à nouveau les prix",
        "totalSalesValueNotEqualToParts": "On dirait que la valeur totale des ventes n'est pas égale à la somme de ses parties"
      }
    }
  }
}